import LinkUnavailable from './LinkUnavailable';

export default LinkUnavailable;
